// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-form-item[data-v-1d95c924] {\r\n    border-bottom: 2px solid #eee;\r\n    margin-bottom: 5px;\n}\r\n", ""]);
// Exports
module.exports = exports;
